// The marketing website hosts the legal and help pages. Optional override for non-production builds.
const base = (import.meta.env.VITE_WEBSITE_URL || 'https://roadfootage.com').replace(/\/+$/, '')

export const websiteLinks = {
  about: `${base}/about`,
  help: `${base}/help`,
  terms: `${base}/terms`,
  privacy: `${base}/privacy`,
  // The media licence is section 5 of the Terms of Use; there is no separate page.
  mediaLicence: `${base}/terms`
}
